import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import CategoryService from "@/features/categories/service/categoryService";
import { toast } from "sonner";
import { Category } from "@/features/categories/service/categoryService";
import { useTranslation } from "@/shared/i18n";

export const useCategoryOrder = () => {
    const { t } = useTranslation('categories');
    const queryClient = useQueryClient();
    const [isSaving, setIsSaving] = useState(false);

    const saveOrder = async (
        orderedCategories: Category[],
        removedCategoryIds: string[]
    ) => {
        setIsSaving(true);

        try {
            // Atualiza as categorias ordenadas com suas novas ordens
            const updatePromises = orderedCategories.map((category, index) => {
                if (!category.id) return Promise.resolve();

                return CategoryService.Instance.updateCategory.actionBuilder({
                    id: category.id,
                    data: {
                        order: index + 1, // Ordem começa em 1
                    },
                })();
            });

            // Atualiza as categorias removidas para order = null
            const removeOrderPromises = removedCategoryIds.map((categoryId) => {
                return CategoryService.Instance.updateCategory.actionBuilder({
                    id: categoryId,
                    data: {
                        order: null,
                    },
                })();
            });

            // Executa todas as requisições em paralelo (pode ser array vazio se não houver mudanças)
            const allPromises = [...updatePromises, ...removeOrderPromises];
            if (allPromises.length > 0) {
                await Promise.all(allPromises);
            }

            // Invalida as queries para atualizar a listagem
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            queryClient.invalidateQueries({ queryKey: ["get-category-by-id"] });

            toast.success(t('orderSaved'));
        } catch (error) {
            console.error(t('errorSavingOrder'), error);
            toast.error(t('errorSavingOrder'));
            throw error;
        } finally {
            setIsSaving(false);
        }
    };

    return {
        saveOrder,
        isSaving,
    };
};

